var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3578 7.99054L9.2615 13.8097C8.91512 14.1215 8.39555 14.1215 8.08381 13.7751C7.77206 13.4287 7.77206 12.9092 8.11844 12.5974L12.7253 8.19837H0.948345C0.463411 8.19837 0.117029 7.85199 0.117029 7.36705C0.117029 6.91676 0.463411 6.53574 0.948345 6.53574H12.7253L8.11844 2.17133C7.77206 1.85958 7.77206 1.30537 8.08381 0.99363C8.39555 0.647249 8.94976 0.647249 9.2615 0.958992L15.3578 6.7782C15.531 6.95139 15.6349 7.15922 15.6349 7.36705C15.6349 7.60952 15.531 7.81735 15.3578 7.99054Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlack);
export default __webpack_public_path__ + "static/media/arrow-right-black.503bca90cc80300eaa637c8892afa5fd.svg";
export { ForwardRef as ReactComponent };